import njwt from "njwt"
import hmacSHA256 from 'crypto-js/hmac-sha256';
import Base64 from 'crypto-js/enc-base64';
import axios from "axios"
import https from "https"
import {
  HOTEL_API_TOKEN_CREDENTIALS,
  TOMORROW_YYYYMMDD,
  THREE_DAYS_FROM_TODAY_YYYYMMDD,
  SNAP_BASE_ENDPOINT,
  ZODIAC_BASE_PATH,
  HOTELS_BASE_PATH,
  STATIC_FILE_PATH,
  HOTELS_API_CREDS
} from "./constant"
import _ from "lodash"
import { add, format } from 'date-fns';
import { getStationDetails_local } from "./stations";

const agent = new https.Agent({
  rejectUnauthorized: false
});


const airportData = require('./airport-data.json');

export const getGtmUserType = () => {
  let gtmUserType = "NewUser"

  if (
    typeof localStorage !== "undefined" &&
    localStorage.getItem("recentSearches")
  ) {
    gtmUserType = "ReturnNonPersonalizedUser"
  }

  return gtmUserType
}

export const fireGtmEvent = obj => {
  try{
    if (typeof window !== "undefined") {
      window.gtmDataLayer = window.gtmDataLayer || []
      window.gtmDataLayer.push(obj)
    }
  }catch(err){
    console.error("Error in firing GTM event", err);
  }
}

// for Hotels API
export const generateToken = () => {
  const claims = {
    iss: HOTEL_API_TOKEN_CREDENTIALS.iss_key,
  }

  const token = njwt.create(claims, HOTEL_API_TOKEN_CREDENTIALS.secret)
  token.setExpiration(new Date().getTime() + 60 * 1000 * 60) // exp for 1 hour 60milisecs x 1000 x 60 minutes)

  return token.compact()
}

export const generateHotelsApiToken = (creds) => {
  const claims = {
    iss: creds.key,
  }

  const token = njwt.create(claims, creds.secret)
  token.setExpiration(new Date().getTime() + 60 * 1000 * 60) // exp for 1 hour 60milisecs x 1000 x 60 minutes)

  return token.compact()
}

// for SNAP API
export const getSnapHotelDetailInstance = (origin, destination, authToken) => {
  const SNAP_HOTEL_LISTING = axios.create({
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    params: {
      adults: "1",
      country_code: "MY",
      currency: "MYR",
      orig: origin,
      dest: destination,
      fromDateFlight: TOMORROW_YYYYMMDD,
      toDateFlight: THREE_DAYS_FROM_TODAY_YYYYMMDD,
      language: "en-us",
      rooms: "1",
    },
  })

  return SNAP_HOTEL_LISTING
}

export const splitRouteNameToArray = routeString => {
  if(_.has(routeString, "split") && _.isFunction(routeString.split)){
    return routeString?.split(" to ")
  }else{
    return ['KUL', 'LGK']
  }
}

export const formatDateToDayNameMonthName = dateString => {
  const dateObject = new Date(dateString)

  const dd = dateObject.getDate()
  const dayName = dateObject.toLocaleString("default", { weekday: "short" })
  const monthName = dateObject.toLocaleString("default", { month: "short" })

  return `${dayName}, ${dd} ${monthName}`
}

export const createSnapDeeplink = (orig, dest, apiDeeplink) => {
  apiDeeplink = apiDeeplink.replace(
    SNAP_BASE_ENDPOINT + "/snap-services/hotel/",
    ""
  )
  apiDeeplink = apiDeeplink.split("?")

  const hotelId = apiDeeplink[0]

  return `https://www.airasia.com/snap/hotels/list?adults=1&country_code=MY&currency=MYR&orig=${orig}&dest=${dest}&fromDateFlight=${TOMORROW_YYYYMMDD}&toDateFlight=${THREE_DAYS_FROM_TODAY_YYYYMMDD}&language=en-gb&hotel_IDs=${hotelId}`
}

export const nextMonthSameDate = () => new Date(new Date().setMonth((new Date().getMonth()) + 1)).toISOString().split("T")[0].split("-").reverse().join("/");
export const sameDateInThreeMonths = () => new Date(new Date().setMonth((new Date().getMonth()) + 4)).toISOString().split("T")[0].split("-").reverse().join("/");
export const nextWeekSameDate = () => new Date(new Date().setDate((new Date().getDate()) + 7)).toISOString().split("T")[0].split("-").reverse().join("/");

const getCarrierImageURL = (literalURL, carrierCode) => {
  return literalURL.replace("{carrier_code}", carrierCode);
}

const durationKeyWordsTranslations = {
  "en-gb": {
    hour: "hour",
    hours: "hours",
    minute: "minute",
    minutes: "minutes",
    second: "second",
    seconds: "seconds"
  },
  "th-th": {
    hour: "ชม.",
    hours: "ชม.",
    minute: "น.",
    minutes: "น.",
    second: "วินาที",
    seconds: "วินาที"
  },
  "ms-my": {
    hour: "jam",
    hours: "jam",
    minute: "minit",
    minutes: "minit",
    second: "sekon",
    seconds: "sekon"
  },
  "id-id": {
    hour: "jam",
    hours: "jam",
    minute: "menit",
    minutes: "menit",
    second: "sekon",
    seconds: "sekon"
  },
  "vi-vn": {
    hour: "giờ",
    hours: "giờ",
    minute: "phút",
    minutes: "phút",
    second: "giây",
    seconds: "giây"
  },
  "km-kh": {
    hour: "ម៉ោង",
    hours: "ម៉ោង",
    minute: "នាទី",
    minutes: "នាទី",
    second: "វិនាទី",
    seconds: "វិនាទី"
  }
};

function secondsToHms(d, lang="en-gb") {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor(d % 3600 / 60);
  var s = Math.floor(d % 3600 % 60);

  var hDisplay = h > 0 ? h + (h == 1 ? ` ${_.get(durationKeyWordsTranslations, `${lang}.hour`)} ` : ` ${_.get(durationKeyWordsTranslations, `${lang}.hours`)} `) : "";
  var mDisplay = m > 0 ? m + (m == 1 ? ` ${_.get(durationKeyWordsTranslations, `${lang}.minute`)} ` : ` ${_.get(durationKeyWordsTranslations, `${lang}.minutes`)} `) : "";
  var sDisplay = s > 0 ? s + (s == 1 ? ` ${_.get(durationKeyWordsTranslations, `${lang}.second`)}` : ` ${_.get(durationKeyWordsTranslations, `${lang}.seconds`)} `) : "";
  return hDisplay + mDisplay + sDisplay; 
}

export const getAirAsiaPrioritised = (list) => {
  // return list
  return _.sortBy(list, o => {
    let carrierNamesString = _.get(o, "carriers", []).map(x => _.get(x, "marketingCarrierName")).join(" ");
    let indexOfAirAsiaInCarrierNamesString = carrierNamesString.match(/airasia/gi)?.index || 200000;
    return indexOfAirAsiaInCarrierNamesString
  })
}

export const getAirAsiaPrioritisedNew = (list, carriers) => {
  const tempmSortedResults = _.reduce(list, (acc, o) => {
    let carrierCodes = _.get(o, "flightDetails.segments", []).map(x => _.get(x, "marketingCarrierCode"));
    let carrierNamesString = carrierCodes.map(x => _.get(carriers, x)).join(" ")
    // let indexOfAirAsiaInCarrierNamesString = carrierNamesString.match(/airasia/gi)?.index || 200000;
    let indexOfAirAsiaInCarrierNamesString = /airasia/gi.exec(carrierNamesString)?.index;
    // let finalIndex = _.isInteger(indexOfAirAsiaInCarrierNamesString) ? indexOfAirAsiaInCarrierNamesString : 200000;
    // return finalIndex;
    if(_.isInteger(indexOfAirAsiaInCarrierNamesString)){
      acc.aa.push(o)
    }else{
      acc.others.push(o)
    }
    return acc;
  }, {aa: [], others: []});
  console.log("tempmSortedResults", tempmSortedResults, list);
  const finalSortedResults = _.concat(_.take(tempmSortedResults.aa, 2), _.take(tempmSortedResults.others, 3));
  // const finalSortedResults = _.concat(tempmSortedResults.aa, _.take(tempmSortedResults.others, 3));
  return finalSortedResults;
}

export async function getFlightData(origin, destination, currency, token, lang, isRouteAA=false) {
  const searchType = isRouteAA ? 'paired' : 'bundled';
  var myHeaders = new Headers();
  myHeaders.append("channel_hash", "8562db67d632fc220ea2eefaf9b8074e3dc156f468ebe0270decef48312bad15");
  myHeaders.append("User-Type", "ANONYMOUS");
  myHeaders.append("Authorization", "Bearer " + token);
  myHeaders.append("Content-Type", "application/json");

  let dates = {
    nextWeek: nextWeekSameDate(),
    nextMonth: nextMonthSameDate(),
    inThreeMonths: sameDateInThreeMonths()
  }

  var raw = JSON.stringify({
    "consumerId": "ListingAPP",
    "flightJourney": {
      "journeyType": "O",
      "journeyDetails": [
        {
          "departDate": dates.nextMonth,
          "origin": origin,
          "destination": destination
        }
      ],
      "passengers": {
        "adult": 1,
        "child": 0,
        "infant": 0
      }
    },
    "searchContext": {
      "promocode": " ",
      "sort": "CHEAPEST",
      "filters": {
        "cabin": {
          "applyMixedClasses": false,
          "cabinClass": "ECONOMY"
        },
        "carriers": {
          "allowAllCarriers": true,
          "excludedCarriers": [],
          "onlyAllowedCarriers": []
        },
        "duration": {
          "maxStopoverTimeInHrs": 0,
          "maxTravelTimeInHrs": 0
        },
        "stops": {
          "allowOvernight": false,
          "stopType": "ANY"
        }
      }
    },
    "userContext": {
      "currency": currency || "MYR",
      "geoId": "MY",
      "locale": lang
    }
  });

  var rawForInThreeMonths = JSON.stringify({
    "consumerId": "ListingAPP",
    "flightJourney": {
      "journeyType": "O",
      "journeyDetails": [
        {
          "departDate": dates.inThreeMonths,
          "origin": origin,
          "destination": destination
        }
      ],
      "passengers": {
        "adult": 1,
        "child": 0,
        "infant": 0
      }
    },
    "searchContext": {
      "promocode": " ",
      "sort": "CHEAPEST",
      "filters": {
        "cabin": {
          "applyMixedClasses": false,
          "cabinClass": "ECONOMY"
        },
        "carriers": {
          "allowAllCarriers": true,
          "excludedCarriers": [],
          "onlyAllowedCarriers": []
        },
        "duration": {
          "maxStopoverTimeInHrs": 0,
          "maxTravelTimeInHrs": 0
        },
        "stops": {
          "allowOvernight": false,
          "stopType": "ANY"
        }
      }
    },
    "userContext": {
      "currency": currency || "MYR",
      "geoId": "MY",
      "locale": lang
    }
  });

  var rawForWeekData = JSON.stringify({
    "consumerId": "ListingAPP",
    "flightJourney": {
      "journeyType": "O",
      "journeyDetails": [
        {
          "departDate": dates.nextWeek,
          "origin": origin,
          "destination": destination
        }
      ],
      "passengers": {
        "adult": 1,
        "child": 0,
        "infant": 0
      }
    },
    "searchContext": {
      "promocode": " ",
      "sort": "CHEAPEST",
      "filters": {
        "cabin": {
          "applyMixedClasses": false,
          "cabinClass": "ECONOMY"
        },
        "carriers": {
          "allowAllCarriers": true,
          "excludedCarriers": [],
          "onlyAllowedCarriers": []
        },
        "duration": {
          "maxStopoverTimeInHrs": 0,
          "maxTravelTimeInHrs": 0
        },
        "stops": {
          "allowOvernight": false,
          "stopType": "ANY"
        }
      }
    },
    "userContext": {
      "currency": currency || "MYR",
      "geoId": "MY",
      "locale": lang
    }
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  const searchURL = `${ZODIAC_BASE_PATH}/seo/fp/search/flights/v5/aggregated-results?airlineProfile=${isRouteAA ? 'all' : 'k,g'}&type=${searchType}&isOriginCity=false&isDestinationCity=false`;

  let weeklyData = await fetch(searchURL, { ...requestOptions, body: rawForWeekData })
    .then(response => response.json())
    .then(result => result).then(result => {
      let list_of_carriers = []
      let flights = searchType === 'paired' ?  result?.searchResults?.trips?.[0]?.flightsList || [] : result?.searchResults?.trips || [];
      let locale = result?.locale || {};
      let flightsWithCarrierData = [];
      if (flights?.length > 0) {
        flightsWithCarrierData = flights.map((flight) => {
          let temp = JSON.parse(JSON.stringify(flight));
          let carriers = temp?.flightDetails?.depart?.segments?.map(segment => ({
            marketingCarrierCode: segment.marketingCarrierCode,
            marketingCarrierName: result?.searchResults?.carriers?.[segment.marketingCarrierCode] || "Carrier Name",
            image: getCarrierImageURL(`${result?.content?.[temp?.airlineProfile || ""][0]?.images?.[0]?.carrierLogo64}?default=airline.png`, segment?.marketingCarrierCode)
          }));
          temp["carriers"] = carriers;
          temp["locale"] = locale;
          list_of_carriers.concat(carriers);
          temp.flightDetails.segments = temp?.flightDetails?.depart?.segments;
          return temp;
        });
      }

      // let airasiaPrioritisedList = _.sortBy(flightsWithCarrierData, o => {
      //   let carrierNamesString = _.get(o, "carriers", []).map(x => _.get(x, "marketingCarrierName")).join(" ");
      //   let indexOfAirAsiaInCarrierNamesString = carrierNamesString.match(/airasia/gi)?.index || 200000;
      //   return indexOfAirAsiaInCarrierNamesString
      // })

      let cheapestFlights = _.take(getAirAsiaPrioritised(_.sortBy(flightsWithCarrierData, o => o.convertedPrice)), 3);
      let fastestFlights = _.take(getAirAsiaPrioritised(_.sortBy(flightsWithCarrierData, o => _.get(o, "flightDetails.duration.total"))), 3);
      let directFlights = _.take(getAirAsiaPrioritised(_.filter(flightsWithCarrierData, o => _.get(o, "flightDetails.numberOfStops.total") === 0)), 3);

      return { cheapestFlights, fastestFlights, directFlights, wholeData: result, searchType, isRouteAA };
    })
    .catch(error => console.log(`error in getting weekly flight data for ${origin} -- ${destination}`, error));

  let inThreeMonthsData = await fetch(searchURL, { ...requestOptions, body: rawForInThreeMonths })
    .then(response => response.json())
    .then(result => result).then(result => {
      let list_of_carriers = []
      let flights = searchType === 'paired' ? result?.searchResults?.trips?.[0]?.flightsList || [] : result?.searchResults?.trips || [];
      let locale = result?.locale || {};
      let flightsWithCarrierData = [];
      if (flights?.length > 0) {
        flightsWithCarrierData = flights.map((flight) => {
          let temp = JSON.parse(JSON.stringify(flight));
          let carriers = temp?.flightDetails?.depart?.segments?.map(segment => ({
            marketingCarrierCode: segment.marketingCarrierCode,
            marketingCarrierName: result?.searchResults?.carriers?.[segment.marketingCarrierCode] || "Carrier Name",
            image: getCarrierImageURL(`${result?.content?.[temp?.airlineProfile || ""][0]?.images?.[0]?.carrierLogo64}?default=airline.png`, segment?.marketingCarrierCode)
          }));
          temp["carriers"] = carriers;
          temp["locale"] = locale;
          list_of_carriers.concat(carriers);
          temp.flightDetails.segments = temp?.flightDetails?.depart?.segments;
          return temp;
        });
      }

      // let airasiaPrioritisedList = _.sortBy(flightsWithCarrierData, o => {
      //   let carrierNamesString = _.get(o, "carriers", []).map(x => _.get(x, "marketingCarrierName")).join(" ");
      //   let indexOfAirAsiaInCarrierNamesString = carrierNamesString.match(/airasia/gi)?.index || 200000;
      //   return indexOfAirAsiaInCarrierNamesString
      // })

      let cheapestFlights = _.take(getAirAsiaPrioritised(_.sortBy(flightsWithCarrierData, o => o.convertedPrice)), 3);
      let fastestFlights = _.take(getAirAsiaPrioritised(_.sortBy(flightsWithCarrierData, o => _.get(o, "flightDetails.duration.total"))), 3);
      let directFlights = _.take(getAirAsiaPrioritised(_.filter(flightsWithCarrierData, o => _.get(o, "flightDetails.numberOfStops.total") === 0)), 3);

      return { cheapestFlights, fastestFlights, directFlights, wholeData: result, searchType, isRouteAA };
    })
    .catch(error => console.log(`error in getting weekly flight data for ${origin} -- ${destination}`, error));

    // https://flights.stgairasia.com/search/aggregator/v4/page-results

  return await fetch(searchURL, requestOptions)
    .then(response => response.json())
    .then(result => result).then(result => {
      // console.log("final step")
      let list_of_carriers = []
      let flights = searchType === 'paired' ?  result?.searchResults?.trips?.[0]?.flightsList || [] : result?.searchResults?.trips || [];
      let locale = result?.locale || {};
      let flightsWithCarrierData = [];
      if (flights?.length > 0) {
        flightsWithCarrierData = flights.map((flight) => {
          let temp = JSON.parse(JSON.stringify(flight));
          let carriers = temp?.flightDetails?.depart?.segments?.map(segment => {
            list_of_carriers.push(result?.searchResults?.carriers?.[segment.marketingCarrierCode] || "Carrier Name")
            return ({
              marketingCarrierCode: segment.marketingCarrierCode,
              marketingCarrierName: result?.searchResults?.carriers?.[segment.marketingCarrierCode] || "Carrier Name",
              image: getCarrierImageURL(`${result?.content?.[temp?.airlineProfile || ""][0]?.images?.[0]?.carrierLogo64}?default=airline.png`, segment?.marketingCarrierCode)
            })
          });
          temp["carriers"] = carriers;
          temp["locale"] = locale;
          // list_of_carriers.concat(carriers);
          temp.flightDetails.segments = temp?.flightDetails?.depart?.segments;

          return temp;
        });
      }

      // let airasiaPrioritisedList = _.sortBy(flightsWithCarrierData, o => {
      //   let carrierNamesString = _.get(o, "carriers", []).map(x => _.get(x, "marketingCarrierName")).join(" ");
      //   let indexOfAirAsiaInCarrierNamesString = carrierNamesString.match(/airasia/gi)?.index || 200000;
      //   return indexOfAirAsiaInCarrierNamesString
      // })

      let cheapestFlights = _.take(getAirAsiaPrioritised(_.sortBy(flightsWithCarrierData, o => _.get(o, "convertedPrice"))), 3);
      let fastestFlights = _.take(getAirAsiaPrioritised(_.sortBy(flightsWithCarrierData, o => _.get(o, "flightDetails.duration"))), 3);
      let directFlights = _.take(getAirAsiaPrioritised(_.filter(flightsWithCarrierData, o => _.get(o, "flightDetails.numberOfStops") === 0)), 3);


      let cheapestFlight = _.minBy(cheapestFlights, x => x.convertedPrice)
      let fastestFlight = _.minBy(fastestFlights, x => _.get(x, "flightDetails.duration"));
      let cheapestPrice = `${_.get(cheapestFlight, "userCurrencyCode", "-")} ${_.ceil(_.get(cheapestFlight, "convertedPrice", "-"))}`;
      let list_of_airlines = _.values(_.get(result, "searchResults.carriers"));
      let flight_duration = secondsToHms(_.get(fastestFlight, "flightDetails.duration"), lang);

      // console.log("cheapestFlighttttttttttttttttttt --- ", cheapestFlight)


      return { 
        cheapestFlights, 
        fastestFlights, 
        directFlights,
        cheapestFlightsInThreeMonths: inThreeMonthsData.cheapestFlights,
        fastestFlightsInThreeMonths: inThreeMonthsData.fastestFlights,
        directFlightsInThreeMonths: inThreeMonthsData.directFlights, 
        cheapestWeeklyFlight: weeklyData.cheapestFlights, 
        wholeDataOfWeek: weeklyData.wholeData, 
        wholeDataOfInThreeMonths: inThreeMonthsData.wholeData,
        wholeDataOfMonth: result,  
        cheapestFlight, 
        cheapestPrice, 
        list_of_airlines, 
        flight_duration, 
        searchType, 
        isRouteAA,
        dates  
      };
    })
    .catch(error => console.log(`error in getting monthly flight data for ${origin} -- ${destination}`, error));

}

export async function getFlightDataWithToken(data, currency, lang, isAaRoute=false) {

  // console.log("from getFlightDataWithToken ---- starting");

  console.log("currency currency currency --- ", currency)

  var routeFromTo = data.routes.split(" to ")
  if (routeFromTo.length < 2) {
    routeFromTo = data.routes.split(" - ")
  }

  var destCode = routeFromTo[routeFromTo.length - 1]
  var originCode = routeFromTo[0]

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    "username": "seo",
    "password": (process.env.GATSBY_ENV === 'dev' || process.env.GATSBY_ENV === 'stg') ? "ggBNuw8rRT6gpKGF" : "yrgbbhfPbLAVm4jE"
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  return await fetch(`${ZODIAC_BASE_PATH}/fp/authentication/auth/login`, requestOptions)
    .then(response => {
      // console.log("response.json step")
      return response.json()
    })
    .then((result) => {
      // console.log("from getFlightDataWithToken ---- entering second stage");
      // console.log("JWT ==== ", result?.jwt)
      return getFlightData(originCode, destCode, currency, result?.jwt, lang, isAaRoute);
    }).catch(error => { console.log('error in zodiac authentication', error); return error; });



}

export function getOrgDestFromData(data){
  var routeFromTo = data.routes.split(" to ")
  if (routeFromTo.length < 2) {
    routeFromTo = data.routes.split(" - ")
  }

  var destCode = routeFromTo[routeFromTo.length - 1]
  var originCode = routeFromTo[0]

  return {origin: originCode, destination: destCode};
}

export function getHotelsApiToken(apiKey, apiSecret){
    var jwtTokenKey = apiKey;
    var jwtTokenSecret = apiSecret;
    var header = '{"alg": "HS256","typ": "JWT"}';
    var body = '{"iss": "'+ jwtTokenKey +'","exp": ' + (Math.floor(new Date().getTime() / 1000) + 300) + '}';
    var payload = btoa(header) + "." + btoa(body);
    var signature = hmacSHA256(payload, jwtTokenSecret);
    return 'Bearer ' + payload + '.' + Base64.stringify(signature);
}

export async function getHotelsData(data={}, currency='MYR', lang="en-us"){

  let startDate = add(new Date(), {weeks: 2});
  let endDate = add(startDate, {days: 1});

  let formattedStartDate = format(startDate, 'yyyy-MM-dd');
  let formattedEndDate = format(endDate, 'yyyy-MM-dd');

  const {destination} = getOrgDestFromData(data);
  const airportObj = _.find(airportData, {iataAirportCode: _.upperCase(destination)}) || {};
  const locationId = _.get(airportObj, "region.id", "180008");
  const countryCode = _.get(airportObj, "countryCode", "MY");
  const smartFillUrl = `${HOTELS_BASE_PATH}/smartfill/v2/smartfill/airport/${destination}?language=${lang}`;
  // const token = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJHa3NPMkI4VWo0azFWSGlVSjV2bTRtVkx3RlFhRXkzVSIsImlhdCI6IjE2NzY0NDQ3OTcuMSIsImF1ZCI6Imp3dC1zbWFydGZpbGwiLCJleHAiOjE2NzY0NDU2OTcsInN1YiI6IjM5OWI4NDk2LTJhMDYtNGZkOC1hODc3LTEzMzJmMjg4ZTZmOCJ9.jdaKcUYmjIj1KTjM0BrLPHc4Lvf7K4wnEO8qJaMaXz4`;
  // const token = getHotelsApiToken(HOTELS_API_CREDS.key, HOTELS_API_CREDS.secret);
  const token = generateHotelsApiToken(HOTELS_API_CREDS);
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + token);
  myHeaders.append("Client-Id", HOTELS_API_CREDS.clientId);
  myHeaders.append("Content-Type", "application/json");
  const requestOptionsForSmartFillApi = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };
  // https://hotelsbe.apiairasia.com/bff/search/v2/hotels?currency=${currency}&country_code=MY&checkin=${formattedStartDate}&checkout=${formattedEndDate}&occupancy=1&location_id=${locationId}&hotels_size=100&language=en-us

  const hotelsDataUrl = `${HOTELS_BASE_PATH}/bff/search/v2/hotels?currency=${currency}&country_code=${countryCode}&checkin=${formattedStartDate}&checkout=${formattedEndDate}&occupancy=1&location_id=${locationId}&hotels_size=100&language=${lang}`
  const hotelsData = await fetch(hotelsDataUrl, requestOptionsForSmartFillApi).then(resp => resp.json()).catch(err => {
    console.error(err);
    return {};
  });

  const finalData = _.get(hotelsData, 'hotels', []).map(x => ({...x, countryCode, locationId, startDate: formattedStartDate, endDate: formattedEndDate, currency, lang}))

  return finalData;
}

export async function getStationsDetails(lang, org, dest) {
  if(_.includes(['en-gb', 'id-id', 'th-th'], lang)){
    return {orgStation: getStationDetails_local(lang, org), destStation: getStationDetails_local(lang, dest)}
  }
  let fileUrl = `${STATIC_FILE_PATH}/flights/station/v2/${lang}/file.json`;
  const stations = await fetch(fileUrl).then(resp => resp.json()).catch(err => {
    console.error(err);
    return {};
  });
  let orgStation = _.find(stations, {StationCode: _.upperCase(org)});
  let destStation = _.find(stations, {StationCode: _.upperCase(dest)});
  return{orgStation, destStation};
}

export const getUrlWithLanguage = (lang, url) => {
  let returnUrl = url;
  switch (lang) {
    case 'vi-vn':
      returnUrl = `/vi/vn${url}`;
      break;
    case 'ph-ph':
      returnUrl = `/ph/ph${url}`;
      break;
    case 'zh-cn':
      returnUrl = `/zh/cn${url}`;
      break;
    case 'th-th':
      returnUrl = `/th/th${url}`;
      break;
    case 'id-id':
      returnUrl = `/id/id${url}`;
      break;
    default:
      returnUrl = url;
      break;
  };
  return returnUrl;
}

export const getStickyBannerImageByLang = (lang) => {
  switch(lang){
    case 'zh-tw': 
      return 'https://storage.googleapis.com/static.airasia.com/seo/images/others/asau_tw.svg';
    case 'zh-cn':
      return 'https://storage.googleapis.com/static.airasia.com/seo/images/others/asau_cn.svg';
    case 'th-th':
      return 'https://storage.googleapis.com/static.airasia.com/seo/images/others/asau_th.svg';
    default:
      return 'https://storage.googleapis.com/static.airasia.com/seo/images/others/asau_en.svg';
  }
}


let metaTemplates = {
  'en-gb': {
    route: {
      title: 'Cheap Flights from {{origin}} to {{destination}} | AirAsia MOVE',
      description: 'Find cheap flights from {{origin}} to {{destination}}. Compare flight prices and get unbeatable discounts for your flight from {{origin}} to {{destination}}. Book now on AirAsia MOVE!'
    },
    destination: {
      title: 'Cheap Flights to {{destination}} | AirAsia MOVE',
      description: 'Get your cheap flight to {{destination}} today! Compare your {{destination}} flight ticket prices and find the perfect travel options that fit your budget. Book your cheap flights at AirAsia MOVE!'
    }
  },
  'id-id': {
    route: {
      title: 'Tiket Pesawat {{origin}} ke {{destination}} | AirAsia MOVE',
      description: 'Dapatkan penawaran tiket pesawat {{origin}}-{{destination}} dengan harga terbaik hanya di AirAsia MOVE. Cek jadwal penerbangan {{origin}} ke {{destination}} hari ini dan pesan tiket Anda sekarang!'
    },
    destination: {
      title: 'Tiket Pesawat ke {{destination}} | AirAsia MOVE',
      description: 'Dapatkan tiket pesawat murah ke {{destination}} hanya di AirAsia MOVE! Cek jadwal penerbangan serta harga tiket ke {{destination}} dan pesan tiket pesawat Anda hari ini!'
    }
  },
  'th-th': {
    route: {
      title: 'จองตั๋วเครื่องบิน{{origin}} ({{origin_code}}) - {{destination}} ({{destination_code}}) ราคาถูก | AirAsia MOVE',
      description: 'หาตั๋วเครื่องบิน{{origin}} ({{origin_code}}) - {{destination}} ({{destination_code}}) ราคาถูก เช็คราคาเที่ยวบินสุดประหยัด เลือกจองตั๋วจากแอร์เอเชียและสายการบินอื่นๆ ได้ที่นี่ที่เดียว จองเลยที่ AirAsia MOVE'
    },
    destination: {
      title: 'จองตั๋วเครื่องบินไป{{destination}}ราคาถูก | AirAsia MOVE',
      description: 'เช็คราคาตั๋วเครื่องบินไป{{destination}} และซื้อเที่ยวบินราคาถูกจากแอร์เอเชียและอีกหลายสายการบิน อย่าช้า! จองตั๋วไป{{destination}}กับ AirAsia MOVE แล้วเที่ยวให้ฟินเลยตอนนี้!'
    }
  }
}

const formatText = (text, keywords) => {
  let newText = text;
  for(const keyword in keywords){
      newText = newText.replaceAll(`{{${keyword}}}`, keywords[keyword]);
  }
  return newText;
}

export const getTemplatedMeta = (type, lang, keywords) => {
  let meta = _.get(metaTemplates, `${lang}.${type}`, {});
  if(_.isEmpty(meta)){
    return {}
  }
  return {
    title: formatText(meta.title, keywords),
    description: formatText(meta.description, keywords)
  }
}